module.exports = __webpack_public_path__ + "img/sr.871e0ebc.png";